var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOffer = function SvgOffer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.549,
    height: 55.139
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    "data-name": "Gruppe 1223"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.799 41.793H13.346V2.751h32.453Zm-5.116 5.115H8.23V7.866h2.365v36.677h30.088ZM48.549 0H10.596v5.116H5.48V49.66h37.954v-5.116h5.116V0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.204 52.389H2.75V13.347h.44v-2.75H0v44.542h37.954v-3.19h-2.75v.44M29.435 18.131H18.16v2.75h11.276v-2.75M29.573 9.598H18.16v2.75h11.414v-2.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.573 26.173H18.16v2.75h11.414v-2.75M29.435 34.216H18.16v2.75h11.276v-2.75M37.671 12.344h3.9V9.596h-2.527V7.069h-2.75v3.9a1.375 1.375 0 0 0 1.375 1.375M37.671 20.881h3.9v-2.75h-2.527v-2.528h-2.75v3.9a1.375 1.375 0 0 0 1.375 1.375M37.671 29.417h3.9v-2.75h-2.527v-2.526h-2.75v3.9a1.375 1.375 0 0 0 1.375 1.375M37.671 37.955h3.9v-2.75h-2.527v-2.528h-2.75v3.9a1.375 1.375 0 0 0 1.375 1.375"
  }))));
};
export default SvgOffer;